export default {
  HEADER_USER_ACCESS_TOKEN: 'subscribed-member-token',
  HEADER_USER_EMAIL: 'subscribed-member-email',

  STORAGE_ITEM_ACCESS_TOKEN: 'access-token',
  STORAGE_ITEM_EMAIL: 'email',
  STORAGE_ITEM_MEMBER_ID: 'memberId',
};
